module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#automobile",
      toString: function () {
        return this.url;
      }
    }